import { render, staticRenderFns } from "./verticalSubTableCellContent.vue?vue&type=template&id=35d405a4&"
import script from "./verticalSubTableCellContent.vue?vue&type=script&lang=js&"
export * from "./verticalSubTableCellContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/verticalSub/verticalSubTableCellContent.vue"
export default component.exports